const courseSettings = {
  language: "en",
  name: "Python Programming MOOC 2026",
  siteUrl: "https://programming-26.mooc.fi",
  githubUrl: "https://github.com/rage/programming-26",
  subtitle: "Python Programming MOOC",
  slug: "programming-26",
  organizationName: "MOOC",
  tmcCourse: "programming-26",
  quizzesId: "cd4f8cae-9751-456c-bf06-9fd0285d8525",
  tmcOrganization: "mooc",
  bannerPath: "banner.svg",
  showExerciseDescriptionWhenNotLoggedIn: true,
  courseVariants: [
    {
      tmcOrganization: "laurea",
      tmcCourse: "python-english-2026-laurea-henttonen"
    },
    {
      tmcOrganization: "seamk",
      tmcCourse: "basics-of-programming-2023"
    },
    // {
    //   tmcOrganization: "hbc",
    //   tmcCourse: "python-TVT24Eng"
    // },
    // {
    //   tmcOrganization: "insviladegracia",
    //   tmcCourse: "python-viladegracia-2024"
    // },
    // {
    //   tmcOrganization: "hbc",
    //   tmcCourse: "python-TVT21A",
    //   // quizzesId: "5c89b9b6-b8a6-4079-8c4f-a4bbc80b66a4",
    // },
  ],
}

module.exports = courseSettings
